import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
  ) { }

  presentSpinner() {
    this.spinner.show();
  }

  dismissSpinner() {
    this.spinner.hide();
  }

  showWarningToastr(message: string, title?: string) {
    this.toastrService.warning(message, title, {
    })
  }

  showErrorToastr(message: string, title?: string) {
    this.toastrService.error(message, title, {
      timeOut: 3000
    })
  }

  showSuccessToastr(message: string, title?: string) {
    this.toastrService.success(message, title, {
      timeOut: 2000
    })
  }
}
